enum TranslationNamespace {
  Home = 'CreatorDocumentation.Home',
  Navigation = 'CreatorDocumentation.Navigation',
  Article = 'CreatorDocumentation.Article',
  APIReference = 'CreatorDocumentation.APIReference',
  Common = 'CreatorDocumentation.Common',
  TagDescription = 'CreatorDocumentation.TagDescription',
  TagLabel = 'CreatorDocumentation.TagLabel',
  Alerts = 'CreatorDocumentation.Alerts',
  OpenCloud = 'CreatorDocumentation.OpenCloud',
  ScopeSystem = 'CreatorDashboard.ScopeSystem',
  CreatorDashboardHome = 'CreatorDashboard.Home',
  Community = 'CreatorDocumentation.Community',
  Assistant = 'Feature.QNAB',
  UseStudio = 'CreatorDocumentation.UseStudio',
  DashboardError = 'CreatorDashboard.Error',
  NotApproved = 'Feature.NotApproved',
  Moderation = 'Feature.Moderation',
  AppealsPortal = 'Feature.AppealsPortal',
  DashboardModeration = 'CreatorDashboard.Moderation',
  Search = 'CreatorDocumentation.Search',
  CreatorDashboardNavigation = 'CreatorDashboard.Navigation',
  CreatorDashboardControls = 'CreatorDashboard.Controls',
  CreatorDashboardFeatures = 'CreatorDashboard.Features',
  CreatorDashboardAssetTypes = 'CreatorDashboard.AssetTypes',
  Courses = 'CreatorDocumentation.Courses',
}

export default TranslationNamespace;
